// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */

import React from 'react';
import { styled } from '@compiled/react';

import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';
import type { SpaceSelectorProps } from './SpaceSelector.tsx';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const LoadingSpaceSelector = styled.div({
	minHeight: '40px',
});

export const SpaceSelector: LoadableType<SpaceSelectorProps> = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-SpaceSelector" */ './SpaceSelector.tsx'))
			.SpaceSelector,
	loading: () => <LoadingSpaceSelector />,
});

export type {
	SpaceSelectorProps,
	SelectedSpaceOnChangeProps,
	OnLoadDefaultSpaceFcn,
} from './SpaceSelector.tsx';
